import { ArrowLeft } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // Redirect to previous page
  };

  return (
    <div
      className="flex items-center gap-2 h-8 ml-4 lg:ml-0 text-white lg:text-primaryAccent-9 cursor-pointer"
      onClick={handleBackClick}
    >
      <ArrowLeft className="h-4 w-4" />

      <span className="text-xs lg:text-base lg:font-medium whitespace-nowrap">
        Back to website
      </span>
    </div>
  );
};

export default BackButton;
